<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.03
        <br />2019
      </span>
      <span class="tiel">美菜网CEO竟也需要考核？美菜模式持续追梦</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        一个餐厅开始营业的标志是什么呢？那就是等待美菜网配送员前来送上新鲜的食材，这才算是工作的开始，也正是美菜网的无忧上门服务让更多餐厅的工作更顺利进行。
        <br />
        <br />在北京一个寒冷的冬天里，在北五环立水桥的汤立路上，一家名叫百碗香饭店正准备开门营业，老板李桂银一早就到店开始忙活。外面上班族匆匆走过，交织着讲话声汽车发动机的轰鸣声、还有孩童爽朗的笑声，李桂银像往常一样听着这些充满生活气息的声音等待着一天生意的开始。
        <br />
        <br />与此同时，她也在等着美菜配送员送来今天店里需要的蔬菜。她抬头看了看墙上的挂钟，如果照往常的时间，配送员小张还有半小时才到。她埋下头，继续有条不紊地收拾着餐桌上的摆具。突然，门外响起了一阵敲门声：“张哥，李姐，开门了吗，我来给百碗香送菜了。”
        <br />
        <br />
      </div>

      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->

      <p align="center">
        <img src="@/assets/images/new-img/a013_1.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center"></div>
      <p align="center">
        <img src="@/assets/images/new-img/a013_2.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网CEO化身送菜小哥来到百碗香</div>
      <div class="tet-js">
        “送菜”，李桂银心里一惊，“这声音不是小张的”，昨天也没听他说今天找了别人送啊。正纳闷着，敲门声大了，“张哥，李姐，我是美菜的刘传军啊……”。
        <br />
        <br />“刘传军！”，李桂银想起了四年前，第一次给百碗香配送食材的人就叫刘传军，还是山东人，跟他们夫妻是老乡，门外敲门的人也的确带有山东口音。可一个公司领导怎么可能来送菜呢，她带着诧异走上前去给那人开门。
        <br />
        <br />“好久不见啊，李姐。”只见说话的人脸上露出淳朴天真的笑容，李桂银愣了几秒，一下反应过来。
        <br />
        <br />“快请进，快请进，您怎么亲自送菜来了？”
        <br />
        <br />“李姐，我今天给百碗香送完菜，还有一个任务要请您帮我完成，公司对我的KPI考核，也就是请您谈谈对我们美菜的服务是否满意。你们店是美菜的重要商户，所以这次考核肯定少不了您的意见和建议。”
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a013_3.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网CEO刘传军填写KPI考核表</div>
      <div class="tet-js">
        原来，四年前，在李桂银和丈夫决定投身餐饮开饭馆后不久，他们的百碗香就成了美菜的第一家商户。四年来，这家店不仅成了他们一家稳定生活的依靠，也成了餐饮行业高速改变的亲历见证。
        <br />
        <br />彼时，以美菜网为代表的餐饮供应链公司正谋划着变革中国餐饮市场。这家供应链公司的创始人刘传军，是一个地地道道的农民的儿子，他凭着自身的努力与坚毅，成为了中国科学院空间物理学硕士，先后参与研究过神六、神七。但由于与生俱来就亲近土地，亲近农民，刘传军一直关注着中国农业的发展，在看到农产品运输过程中的种种壁垒后，他毅然决然地辞掉当时令人艳羡的科技工作，希望用一种模式打通从田间地头到百姓餐桌的层层环节。
        <br />
        <br />于是，2014年夏天，美菜网正式成立。其独有的“两端一链一平台”模式，通过自建仓储、物流、配送、创新升级农产品的供应链，链接起了田间地头和市场、城市消费两端，实现了农户和餐厅的直接交付。
        <br />
        <br />餐饮行业变革的风口，李桂银夫妇的百碗香便成了美菜网的第一家商户。在刘传军心里，百碗香不仅是美菜的第一家商户，第一个美菜模式的受益者，同时也是他变革农业，追梦路上的第一个见证者。
        <br />
        <br />四年来，从拿下第一个客户百碗香到如今，美菜网已成功积累279万家商户，而美菜业务的版图业已覆盖全国约220个城市，让百碗香李桂银夫妇受益的美菜模式也给更多商户带去便利，同时，更惠及了餐饮供应链上游的亿万农民。
        <br />
        <br />成立四年多来，美菜网不仅成功跻身独角兽行列，在继续深化推动供应链变革的同时，他们还不忘给餐饮人提供品质无忧、价格无忧、选择无忧、服务无忧的采购服务。于创立之初打造的餐饮界狂欢盛典——“美菜节”在经过四年多的发展后，早已以“买菜卖菜上美菜”深入人心。
        <br />
        <br />在正值第五个“美菜节”开启前夕，为了了解客户真实需求，检验美菜服务的含金量。刘传军决定，他要回访美菜网第一家同时也是他以销售身份谈下的第一个商户——百碗香。他认为，企业和个人一样，都要经过三年或四年一回的考试，只有通过考试才知道哪里不足，只有通过考试，才知道如何查漏补缺取得前进的方向。而百碗香作为对美菜而言意义非凡的商户，合作四年多，一定能给美菜的发展提出意见和建议。
        <br />
        <br />于是，刘传军便带着公司员工给他开出的KPI考核表，拎着前一天百碗香下单的蔬菜和美菜精心准备好的新年礼包出现在百碗香的店里。
        <br />
        <br />李桂银说，正是有了美菜模式，他们才有了时间和精力规划并成功在济南开设分店。听完李桂银的讲述，刘传军说，“每次当我听到美菜帮助了农民或是帮助了餐厅老板时，我都特别感动，也特别受鼓舞，因为有你们的肯定，我们才有前进的力量。我们都在努力奔跑，我们都是追梦人。”为了感谢百碗香的支持与信任，同时也为了李桂银夫妇继续追逐餐饮梦，刘传军当即表示赠与百碗香追梦基金。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a013_4.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网CEO为李桂银颁发追梦基金</div>
      <div class="tet-js">
        对于美菜网的追梦模式，更多的是不玩初心的感动，是向着梦想前进的坚持，也是我们现在年轻人身上所缺少的东西。虽然外面的寒风凛冽，但是在很多人心中却是暖融融的，因为怀揣着梦想，也因为美菜网的鼎力支持。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
